<template>
  <a class="http-link" :href="internalHref">
    <slot></slot>
  </a>
</template>
<script>
import mediaMixin from 'src/mixins/mediaMixin'

export default {
  name: 'http-link',
  props: {
    href: {
      type: String,
      default: '',
    },
    filename: {
      type: String,
      default: '',
    },
    isBlobUrl: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalHref: '',
    }
  },
  watch: {
    async href() {
      await this.setLinkUrl()
    }
  },
  async mounted() {
    await this.setLinkUrl()
  },
  beforeDestroy() {
    if (!this.isBlobUrl) {
      URL.revokeObjectURL(this.internalHref)
    }
  },
  mixins: [mediaMixin],
  methods: {
    async setLinkUrl() {
      if (!this.href) { return }
      let url = this.href
      if (!this.isBlobUrl) {
        url = await this.getBlobUrl(this.href)
      }
      this.internalHref = url
      this.$el.download = this.filename
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
